export const ADMIN_FINANCE_MONTH_ROUTE_NAME = Symbol('admin.finance.month');
export const AFFILIATE_FINANCE_MONTH_ROUTE_NAME = Symbol('affiliate.finance.month');

export const ADMIN_FINANCE_MONTH_LIST_ROUTE_NAME = Symbol('admin.finance.month.list');
export const AFFILIATE_FINANCE_MONTH_LIST_ROUTE_NAME = Symbol('affiliate.finance.month.list');

export const FINANCE_MONTH_LIST_API_URL_ADMIN = 'admin/bookkeepings/list_affiliate_month_payments';
export const FINANCE_MONTH_LIST_API_URL_AFFILIATE = 'affiliate/bookkeepings/list_affiliate_month_payments_in_one_month';

export const FINANCE_MONTH_LIST_QUERY_KEY = 'finance.month.list';

export const FINANCE_MONTH_DOWNLOAD_REPORT_URL = ':namespace/bookkeepings/download_report';
export const FINANCE_MONTH_DOWNLOAD_REPORT_MUTATION_KEY = 'finance.month.report';

export const FINANCE_MONTH_APPROVE_URL = 'admin/bookkeepings/approve_month_payment';
export const FINANCE_MONTH_APPROVE_MUTATION_KEY = 'finance.month.approve';

export const FINANCE_MONTH_PAY_URL = 'admin/bookkeepings/pay_month_payment';
export const FINANCE_MONTH_PAY_MUTATION_KEY = 'finance.month.paid';

export const FINANCE_MONTH_PROCESS_URL = 'admin/bookkeepings/process_month_payment';
export const FINANCE_MONTH_PROCESS_MUTATION_KEY = 'finance.month.process';

export const FINANCE_MONTH_TRANSFER_PAYOUT_URL = 'admin/bookkeepings/update_aasm_state_paid_in_next_month';
export const FINANCE_MONTH_TRANSFER_PAYOUT_MUTATION_KEY = 'finance.month.transfer-payout';

export const FINANCE_MONTH_CANCEL_TRANSFER_PAYOUT_URL = 'admin/bookkeepings/update_aasm_state_default_payment';
export const FINANCE_MONTH_CANCEL_TRANSFER_PAYOUT_MUTATION_KEY = 'finance.month.cancel-transfer-payout';

export const FINANCE_MONTH_TRANSFER_PAYOFF_URL = 'admin/bookkeepings/transfer_payoff';
export const FINANCE_MONTH_TRANSFER_PAYOFF_MUTATION_KEY = 'finance.month.transfer-payoff';
